import { React, useState, useEffect, useRef, useContext } from "react";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../../AppStore';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PartnerUserSelectModal from "../../../../modal/PC/common/PartnerUserSelectModal";
import ItemSelectModal from "../../../../modal/PC/common/ItemSelectModal";
import UserSelectModal from "../../../../modal/PC/common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function TAB_PurchaseUpdate({ title, onClose, id, originRows, handleView, userTypeModalOption, unitCurrencyModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    purchase_id: null,
    purchase_number: '',
    purchase_date: appStore.YYYY_MM_DD(),
    purchase_name: '',
    purchase_partner_id: 0,
    purchase_partner_name: '',
    purchase_partner_manager: '',
    purchase_partner_manager_phone: '',
    purchase_partner_manager_mail: '',
    purchase_bigo: '',
    purchase_ref_purchase_id: null,
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectPurchaseModalOpen, setSelectPurchaseModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [upperPartnerId, setUpperPartnerId] = useState(0);
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.purchase_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  const handleInitSelect = () => {
    const t0 = performance.now();

    // 초기화
    tmpRealFiles = [];
    setUpdateItemRows([]);
    setUpdateUserRows([]);
    setUpdateFileRows([]);

    const rows = originRows || [];
    const first = rows[0];
    if (!first) return;

    // 입력 세팅
    setInputs({
      purchase_id: Number(first.purchase_id),
      purchase_number: first.purchase_number,
      purchase_date: first.purchase_date,
      purchase_name: first.purchase_name,
      purchase_partner_id: Number(first.purchase_partner_id),
      purchase_partner_name: first.purchase_partner_name,
      purchase_partner_manager: first.purchase_partner_manager,
      purchase_partner_manager_phone: first.purchase_partner_manager_phone,
      purchase_partner_manager_mail: first.purchase_partner_manager_mail,
      purchase_bigo: first.purchase_bigo,
      purchase_ref_purchase_id: Number(first.purchase_ref_purchase_id),
    });

    // 1패스 분류 + 중복제거(Map)
    const itemMap = new Map(); // key: purchase_item_seq
    const userMap = new Map(); // key: purchase_user_seq
    const fileMap = new Map(); // key: purchase_file_id

    for (const r of rows) {
      if (r.purchase_item_seq !== undefined && !itemMap.has(r.purchase_item_seq)) {
        const spec = ([r.purchase_item_name, r.purchase_item_spec].filter(Boolean).join(' ')
                      + appStore.ITEM_FULL_SPEC_MAKE(
                          r.purchase_item_width,
                          r.purchase_item_depth,
                          r.purchase_item_height
                        )
                    ).trim();
        itemMap.set(r.purchase_item_seq, {
          id: r.purchase_item_seq,
          purchase_item_id: r.purchase_item_id,
          purchase_item_name: spec,
          purchase_package_count: r.purchase_package_count,
          purchase_pack_rate: r.purchase_pack_rate,
          purchase_item_count: r.purchase_item_count,
          purchase_item_price_currency: r.purchase_item_price_currency,
          purchase_item_price: r.purchase_item_price,
          purchase_item_sv_price: r.purchase_item_sv_price,
          purchase_item_vat_price: r.purchase_item_vat_price,
          purchase_item_total_price: r.purchase_item_total_price,
          row_type: 'O',
          update_type: 'N',
        });
      }

      if (r.purchase_user_seq !== undefined && !userMap.has(r.purchase_user_seq)) {
        userMap.set(r.purchase_user_seq, {
          id: r.purchase_user_seq,
          purchase_user_id: r.purchase_user_id,
          purchase_user_name: r.purchase_user_name,
          purchase_user_dept_name: r.purchase_user_dept_name,
          purchase_user_position_name: r.purchase_user_position_name,
          purchase_user_type: r.purchase_user_type,
          purchase_user_bigo: r.purchase_user_bigo,
          row_type: 'O',
          update_type: 'N',
        });
      }

      if (r.purchase_file_id !== undefined && !fileMap.has(r.purchase_file_id)) {
        fileMap.set(r.purchase_file_id, {
          id: r.purchase_file_id,
          file_name_sever: r.purchase_file_name_sever,
          file_size: r.purchase_file_size,
          file_type: r.purchase_file_type,
          file_extension: r.purchase_file_extension,
          file_name: r.purchase_file_name,
          file_type_name: r.purchase_file_type_name,
          file_size_dp: r.purchase_file_size_dp,
          reg_user_name: r.purchase_file_user_name,
          reg_datetime: Moment(r.purchase_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
          row_type: 'O',
          update_type: 'N',
        });
      }
    }

    const t1 = performance.now();

    // 정렬 (고유 건수만 정렬 — 비용↓)
    const itemRows = Array.from(itemMap.values()).sort((a, b) => a.id - b.id);
    const userRows = Array.from(userMap.values()).sort((a, b) => a.id - b.id);
    const fileRows = Array.from(fileMap.values()).sort((a, b) => a.id - b.id);

    const t2 = performance.now();

    // setState (React 18면 자동 배칭)
    setItemRows(itemRows);
    setUserRows(userRows);
    setFileRows(fileRows);
    setOriginFileRows(fileRows);

    // newFileID 갱신(효율적으로 1회만)
    let maxFileId = typeof newFileID === 'number' ? newFileID : 0;
    for (const f of fileRows) if (typeof f.id === 'number' && f.id >= maxFileId) maxFileId = f.id + 1;
    newFileID = maxFileId;

    const t3 = performance.now();
  };

  const handleSetting = () => {
    setItemColumns([
      {
          field: 'actions',
          headerName: '동작',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              ((params.row.update_type === "U")? 
              <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              : (params.row.row_type === "A" && params.row.update_type === "N")? 
              <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
              :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              )
            ],
          headerAlign: 'center', 
          align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'purchase_item_id', headerName: 'purchase_item_id', headerAlign: 'center', align:'center' },
      { field: 'purchase_item_name', headerName: '품목', flex: 1, minWidth: 130, headerAlign: 'center', align:'left' },
      { field: 'purchase_package_count', headerName: '수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_pack_rate', headerName: '포장수량', type: 'number', width: 70, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_count', headerName: '발주수량', type: 'number', width: 90, headerAlign: 'center', align:'right', editable: false },
      { field: 'purchase_item_price_currency', headerName: '통화단위', type: 'singleSelect', width: 80, 
        valueOptions: () => unitCurrencyModalOption ?? [], valueFormmatter: ({  value }) => 
          unitCurrencyModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'purchase_item_price', headerName: '단가', type: 'number',width: 90, headerAlign: 'center', editable: true},
      { field: 'purchase_item_sv_price', headerName: '공급가액', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_vat_price', headerName: '부가세액', type: 'number',width: 90, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_total_price', headerName: '합계금액', type: 'number',width: 110, headerAlign: 'center', align:'right' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'purchase_user_id', headerName: 'purchase_user_id', width: 0, headerAlign: 'center' },
      { field: 'purchase_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
    
    setItemColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      purchase_item_id: false,
      purchase_item_name: true,
      purchase_package_count: true,
      purchase_pack_rate: true,
      purchase_item_count: true,
      purchase_item_price_currency: false,
      purchase_item_price: true,
      purchase_item_sv_price: true,
      purchase_item_vat_price: true,
      purchase_item_total_price: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      purchase_user_id: false,
      purchase_user_name: true,
      purchase_user_dept_name: true,
      purchase_user_position_name: true,
      purchase_user_type: true,
      purchase_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    purchase_item_id: false,
    purchase_item_name: true,
    purchase_package_count: true,
    purchase_pack_rate: true,
    purchase_item_count: true,
    purchase_item_price_currency: false,
    purchase_item_price: true,
    purchase_item_sv_price: true,
    purchase_item_vat_price: true,
    purchase_item_total_price: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    purchase_user_id: false,
    purchase_user_name: true,
    purchase_user_dept_name: true,
    purchase_user_position_name: true,
    purchase_user_type: true,
    purchase_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    handleInitSelect();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  // 🚨 updateFlag 갱신 시 동작(삭제/추가) 컬럼 표시 갱신 (첫 레코드 기준 고정 방지)
  useEffect(() => {
    setItemColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
    setUserColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
    setFileColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
  }, [updateFlag]);


  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        purchase_item_id: '',
        purchase_item_name: '',
        purchase_package_count: '',
        purchase_pack_rate: '',
        purchase_item_count: '',
        purchase_item_price_currency: 144,
        purchase_item_price: 0,
        purchase_item_sv_price: 0,
        purchase_item_vat_price: 0,
        purchase_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }
    
  }, [itemRows, updateFlag]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        purchase_user_id: '',
        purchase_user_name: '',
        purchase_user_dept_name: '',
        purchase_user_position_name: '',
        purchase_user_type: 0,
        purchase_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows, updateFlag]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows, updateFlag]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시
    setSelectModalTitle('발주처 목록')
    setSelectPartnerModalOpen(true);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'purchase_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.purchase_package_count > 99999 || newRow.purchase_pack_rate > 99999){
      return;
    }

    if(oldRow.purchase_item_id !== newRow.purchase_item_id || oldRow.purchase_item_name !== newRow.purchase_item_name 
      || oldRow.purchase_package_count !== newRow.purchase_package_count || oldRow.purchase_pack_rate !== newRow.purchase_pack_rate
      || oldRow.purchase_item_price !== newRow.purchase_item_price || oldRow.purchase_item_sv_price !== newRow.purchase_item_sv_price || oldRow.purchase_item_vat_price !== newRow.purchase_item_vat_price){
      
      let newUpdateDataArray = {}
      const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
      
      // ▼ 수량 혹은 포장이 변경된 경우 총수량 재계산 후 금액 재계산
      if (newRow.purchase_package_count !== oldRow.purchase_package_count || newRow.purchase_pack_rate !== oldRow.purchase_pack_rate){
        const newCount = Number(newRow.purchase_package_count || 0) * Number(newRow.purchase_pack_rate || 1);
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_count']: newCount
          , ['purchase_item_sv_price']: newCount * (newRow.purchase_item_price)
          , ['purchase_item_vat_price']: (newCount * (newRow.purchase_item_price))/10
          , ['purchase_item_total_price']: newCount * (newRow.purchase_item_price) + ((newCount * (newRow.purchase_item_price))/10)
          , update_type: 'U' }; 
      } else if (newRow.purchase_item_price !== oldRow.purchase_item_price) { // 단가가 바뀐경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_sv_price']: newRow.purchase_item_count * (newRow.purchase_item_price)
          , ['purchase_item_vat_price']: (newRow.purchase_item_count * (newRow.purchase_item_price))/10
          , ['purchase_item_total_price']: newRow.purchase_item_count * (newRow.purchase_item_price) + ((newRow.purchase_item_count * (newRow.purchase_item_price))/10)
          , update_type: 'U' }; 
      } else if (newRow.purchase_item_sv_price !== oldRow.purchase_item_sv_price) { // 공급가액을 수정한 경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_vat_price']: (newRow.purchase_item_sv_price/10)
          , ['purchase_item_total_price']: newRow.purchase_item_sv_price+(newRow.purchase_item_sv_price/10)
          , update_type: 'U' }; 
      } else if (newRow.purchase_item_vat_price !== oldRow.purchase_item_vat_price) { // 부가세액을 수정한 경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_total_price']: newRow.purchase_item_sv_price + newRow.purchase_item_vat_price
          , update_type: 'U' }; 
      } else { // 품목 또는 통화 변경이 있는 경우
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }
      
      var row_purchase_item_id = '';
      var row_purchase_item_name = '';
      var row_purchase_package_count = '';
      var row_purchase_pack_rate = '';
      var row_purchase_item_count = '';
      var row_purchase_item_price_currency = 144;
      var row_purchase_item_price = 0;
      var row_purchase_item_sv_price = 0;
      var row_purchase_item_vat_price = 0;
      var row_purchase_item_total_price = 0;

      if(String(newRow.row_type) === "A"){
        if(newRow.purchase_item_id !== '' || newRow.purchase_item_name !== '' || newRow.purchase_package_count !== '' || newRow.purchase_pack_rate !== ''
          || newRow.purchase_item_price_currency !== 144 || newRow.purchase_item_price !== 0 || newRow.purchase_item_sv_price !== 0
          || newRow.purchase_item_vat_price !== 0 || newRow.purchase_item_total_price !== 0){
          row_purchase_item_id = newRow.purchase_item_id;
          row_purchase_item_name = newRow.purchase_item_name;
          row_purchase_package_count = newRow.purchase_package_count;
          row_purchase_pack_rate = newRow.purchase_pack_rate;
          row_purchase_item_count = newRow.purchase_item_count;
          row_purchase_item_price_currency = newRow.purchase_item_price_currency;
          row_purchase_item_price = newRow.purchase_item_price;
          row_purchase_item_sv_price = newRow.purchase_item_sv_price;
          row_purchase_item_vat_price = newRow.purchase_item_vat_price;
          row_purchase_item_total_price = newRow.purchase_item_total_price;
        }
      }else{
        itemRows.map((data) => data.id === newRow.id 
          && (data.purchase_item_id !== newRow.purchase_item_id || data.purchase_item_name !== newRow.purchase_item_name || data.purchase_package_count !== newRow.purchase_package_count || data.purchase_pack_rate !== newRow.purchase_pack_rate
            || data.purchase_item_price_currency !== newRow.purchase_item_price_currency || data.purchase_item_price !== newRow.purchase_item_price
            || data.purchase_item_sv_price !== newRow.purchase_item_sv_price || data.purchase_item_vat_price !== newRow.purchase_item_vat_price
            || data.purchase_item_total_price !== newRow.purchase_item_total_price)?
          (
            row_purchase_item_id = data.purchase_item_id,
            row_purchase_item_name = data.purchase_item_name,
            row_purchase_package_count = data.purchase_package_count,
            row_purchase_pack_rate = data.purchase_pack_rate,
            row_purchase_item_count = data.purchase_item_count,
            row_purchase_item_price_currency = data.purchase_item_price_currency,
            row_purchase_item_price = data.purchase_item_price,
            row_purchase_item_sv_price = data.purchase_item_sv_price,
            row_purchase_item_vat_price = data.purchase_item_vat_price,
            row_purchase_item_total_price = data.purchase_item_total_price
          ):""
        )
      }
      
      if(row_purchase_item_id === '' && row_purchase_item_name === '' && row_purchase_package_count === '' && row_purchase_pack_rate === ''
        && row_purchase_item_price_currency === 144 && row_purchase_item_price === 0 && row_purchase_item_sv_price === 0 && row_purchase_item_vat_price === 0
        && row_purchase_item_total_price === 0){
        if(updateItemRows.length > 0){
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 
  
    if(oldRow.purchase_user_id !== newRow.purchase_user_id || oldRow.purchase_user_type !== newRow.purchase_user_type || oldRow.purchase_user_bigo !== newRow.purchase_user_bigo){
      var row_purchase_user_id = '';
      var row_purchase_user_name = '';
      var row_purchase_user_type = 0;
      var row_purchase_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.purchase_user_id !== '' || newRow.purchase_user_name !== '' || (newRow.purchase_user_type !== 0 && newRow.purchase_user_type !== '') || newRow.purchase_user_bigo !== '' ){
          row_purchase_user_id = newRow.purchase_user_id;
          row_purchase_user_name = newRow.purchase_user_name;
          row_purchase_user_type = newRow.purchase_user_type;
          row_purchase_user_bigo = newRow.purchase_user_bigo;
        }
      }else{
        userRows.map((data) => data.id === newRow.id 
          && (data.purchase_user_id !== newRow.purchase_user_id || data.purchase_user_name !== newRow.purchase_user_name || data.purchase_user_type !== newRow.purchase_user_type || data.purchase_user_bigo !== newRow.purchase_user_bigo )?
          (
            row_purchase_user_id = data.purchase_user_id,
            row_purchase_user_name = data.purchase_user_name,
            row_purchase_user_type = data.purchase_user_type,
            row_purchase_user_bigo = data.purchase_user_bigo
          ):""
        )
      }
      
      if(row_purchase_user_id === '' && row_purchase_user_name === '' && row_purchase_user_bigo === '' && (row_purchase_user_type === 0 || row_purchase_user_type === null)){
        if(updateUserRows.length > 0){
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        purchase_item_id: '',
        purchase_item_name: '',
        purchase_package_count: '',
        purchase_pack_rate: '',
        purchase_item_count: '',
        purchase_item_price_currency: 144,
        purchase_item_price: 0,
        purchase_item_sv_price: 0,
        purchase_item_vat_price: 0,
        purchase_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        purchase_item_id: object.row.purchase_item_id,
        purchase_item_name: object.row.purchase_item_name,
        purchase_package_count: object.row.purchase_package_count,
        purchase_pack_rate: object.row.purchase_pack_rate,
        purchase_item_count: object.row.purchase_item_count,
        purchase_item_price_currency: object.row.purchase_item_price_currency,
        purchase_item_price: object.row.purchase_item_price,
        purchase_item_sv_price: object.row.purchase_item_sv_price,
        purchase_item_vat_price: object.row.purchase_item_vat_price,
        purchase_item_total_price: object.row.purchase_item_total_price,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    if(object.row.row_type === 'O'){
      setUpdateItemRows(prevRows => [...prevRows, {
        id: object.row.id,
        purchase_item_id: object.row.purchase_item_id,
        purchase_item_name: object.row.purchase_item_name,
        purchase_package_count: object.row.purchase_package_count,
        purchase_pack_rate: object.row.purchase_pack_rate,
        purchase_item_count: object.row.purchase_item_count,
        purchase_item_price_currency: object.row.purchase_item_price_currency,
        purchase_item_price: object.row.purchase_item_price,
        purchase_item_sv_price: object.row.purchase_item_sv_price,
        purchase_item_vat_price: object.row.purchase_item_vat_price,
        purchase_item_total_price: object.row.purchase_item_total_price,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    }
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
  };

  const userAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        purchase_user_id: '',
        purchase_user_name: '',
        purchase_user_dept_name: '',
        purchase_user_position_name: '',
        purchase_user_type: 0,
        purchase_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        purchase_user_id: object.row.purchase_user_id,
        purchase_user_name: object.row.purchase_user_name,
        purchase_user_dept_name: object.row.purchase_user_dept_name,
        purchase_user_position_name: object.row.purchase_user_position_name,
        purchase_user_type: object.row.purchase_user_type,
        purchase_user_bigo: object.row.purchase_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        purchase_user_id: object.row.purchase_user_id,
        purchase_user_name: object.row.purchase_user_name,
        purchase_user_dept_name: object.row.purchase_user_dept_name,
        purchase_user_position_name: object.row.purchase_user_position_name,
        purchase_user_type: object.row.purchase_user_type,
        purchase_user_bigo: object.row.purchase_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.style.display = 'none';
    document.body.appendChild(input);
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; 
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows.filter((r) => !(r.row_type === 'A' && r.update_type === 'N')), ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.purchase_file_name_sever,
        file_size: object.row.purchase_file_size,
        file_type: object.row.purchase_file_type,
        file_extension: object.row.purchase_file_extension,
        file_name: object.row.purchase_file_name,
        file_type_name: object.row.purchase_file_type_name,
        file_size_dp: object.row.purchase_file_size_dp,
        reg_user_name: object.row.purchase_file_user_name,
        reg_datetime: Moment(object.row.purchase_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handlePurchaseUpdate = (event) => {
    var status_str = ''
    var change_status = ''
    if(originRows[0].purchase_status === 'S'){ 
      status_str = '취소'
      change_status = 'D'
    } else { 
      status_str = '원복'
      change_status = 'S'
    }

    Swal.fire({
      title: '발주번호 '+originRows[0].purchase_number+' ' + status_str,
      text: '발주를 '+ status_str +' 하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '예', 
      cancelButtonText: '아니오',
      confirmButtonColor: '#0067a3',
      cancelButtonColor: '#d33',
    }).then(result => {
      if (result.isConfirmed) {
        if(change_status === 'D' && originRows[0].incoming_cnt !== 0){ 
          Swal.fire({
              title: '발주 취소 불가',
              text: '입고 완료된 발주는 취소할 수 없습니다.',
              confirmButtonText: '확인',
              timer: 5000,
              timerProgressBar: true
          });
        } else {
          if (appStore.loading) return;
          appStore.setLoading(true);
          
          axios.post('/api/p/Purchase/Update', new URLSearchParams({
              cancel_purchase_id: originRows[0].purchase_id,
              change_status: change_status
          }),
          { withCredentials: true })
          .then(function (response) {
              if(response.status === 200){
                  Swal.fire({
                    title: '발주번호 '+originRows[0].purchase_number+' ' + status_str + ' 완료',
                    text: '정상적으로 발주가 '+status_str+' 되었습니다.',
                    confirmButtonText: '확인',
                    timer: 5000,
                    timerProgressBar: true
                  }).then((result) => {
                    handleView();
                  });
              }else{
                appStore.capture();
              }
          })
          .catch(function (error) {
            appStore.capture();
            console.log("네트워크 실패", error);
          })
          .finally(() => {
            appStore.setLoading(false); 
          });
        }
      }
    })
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'purchase_item_name'){
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        purchase_item_id: params.row.purchase_item_id,
        purchase_item_name: params.row.purchase_item_name,
        purchase_package_count: params.row.purchase_package_count,
        purchase_pack_rate: params.row.purchase_pack_rate,
        purchase_item_count: params.row.purchase_item_count,
        purchase_item_price_currency: params.row.purchase_item_price_currency,
        purchase_item_price: params.row.purchase_item_price,
        purchase_item_sv_price: params.row.purchase_item_sv_price,
        purchase_item_vat_price: params.row.purchase_item_vat_price,
        purchase_item_total_price: params.row.purchase_item_total_price,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'purchase_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        purchase_user_id: params.row.purchase_user_id,
        purchase_user_name: params.row.purchase_user_name,
        purchase_user_dept_name: params.row.purchase_user_dept_name,
        purchase_user_position_name: params.row.purchase_user_position_name,
        purchase_user_type: params.row.purchase_user_type,
        purchase_user_bigo: params.row.purchase_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email

    const nextInputs = {
        ...inputs,
        ["purchase_partner_id"]: object.id,
        ["purchase_partner_name"]: object.partner_name,
        ["purchase_partner_manager"]: partner_user_name,
        ["purchase_partner_manager_phone"]: partner_user_phone,
        ["purchase_partner_manager_mail"]: partner_user_email,
        ["purchase_ref_purchase_id"]: null
    };
    setInputs(nextInputs);
    setUpperPartnerId(object.id);
  };
  
  const handleInputItemClick = (object) => {
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].purchase_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.purchase_item_id){
        if (object.id === '') {
          processItemRowUpdate({
            id: selectItemData.id, purchase_item_id: '', purchase_item_name: '', purchase_package_count: '', purchase_pack_rate: '', purchase_item_count: '',
            purchase_item_price_currency: 144, purchase_item_price: 0, purchase_item_sv_price: 0, purchase_item_vat_price: 0, purchase_item_total_price: 0,
            row_type: selectItemData.row_type, update_type: selectItemData.update_type,
          }, { ...selectItemData });
        } else {
          var item_real_price = 0; 
          if(object.partner_id === inputs.purchase_partner_id && object.item_in_out_type === 'I' && object.item_partner_price !== undefined){
            item_real_price = object.item_partner_price; 
          } else {
            item_real_price = object.item_stock_price; 
          }
          
          processItemRowUpdate(
            {
              id: selectItemData.id,
              purchase_item_id: object.id,
              purchase_item_name: object.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( object.item_spec, object.item_width, object.item_depth, object.item_height),
              purchase_package_count: selectItemData.purchase_package_count,
              purchase_pack_rate: object.item_purchase_package_count || 1, // 품목 마스터의 발주포장비율 맵핑
              purchase_item_count: Number(selectItemData.purchase_package_count || 0) * Number(object.item_purchase_package_count || 1),
              purchase_item_price_currency: object.item_stock_price_currency,
              purchase_item_price: item_real_price,
              purchase_item_sv_price: item_real_price,
              purchase_item_vat_price: selectItemData.purchase_item_vat_price,
              purchase_item_total_price: selectItemData.purchase_item_total_price,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              purchase_item_id: selectItemData.purchase_item_id,
              purchase_item_name: selectItemData.purchase_item_name,
              purchase_package_count: selectItemData.purchase_package_count,
              purchase_pack_rate: selectItemData.purchase_pack_rate,
              purchase_item_count: selectItemData.purchase_item_count,
              purchase_item_price_currency: selectItemData.purchase_item_price_currency,
              purchase_item_price: selectItemData.purchase_item_price,
              purchase_item_sv_price: selectItemData.purchase_item_sv_price,
              purchase_item_vat_price: selectItemData.purchase_item_vat_price,
              purchase_item_total_price: selectItemData.purchase_item_total_price,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    }
  };

  const handleUserClick = (object) => {
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].purchase_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.purchase_user_id){
        
        processUserRowUpdate(
          {
            id : selectUserData.id,
            purchase_user_id: object.id,
            purchase_user_name: object.user_name,
            purchase_user_dept_name: object.dept_name,
            purchase_user_position_name: object.position_name,
            purchase_user_type: (selectUserData.purchase_user_type === 0 || selectUserData.purchase_user_type === '') ? 178 : selectUserData.purchase_user_type,
            purchase_user_bigo: selectUserData.purchase_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            purchase_user_id: selectUserData.purchase_user_id,
            purchase_user_name: selectUserData.purchase_user_name,
            purchase_user_type: (selectUserData.purchase_user_type === 0 || selectUserData.purchase_user_type === '') ? 178 : selectUserData.purchase_user_type,
            purchase_user_dept_name: selectUserData.purchase_user_dept_name,
            purchase_user_position_name: selectUserData.purchase_user_position_name,
            purchase_user_bigo: selectUserData.purchase_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    
    if(inputs.purchase_name.trim() === '' || inputs.purchase_name.trim() === 0){
      msg = '발주명은 필수 입력 입니다.'
    }else if((inputs.purchase_date) === '' || (inputs.purchase_date) < '2025-01-01' || (inputs.purchase_date).length != 10){
      msg = '발주일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.purchase_partner_id === '' || inputs.purchase_partner_id === 0){
      msg = '발주처는 필수 입력 입니다.'
    }else if(inputs.purchase_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.purchase_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.purchase_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.purchase_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }
    
    if(msg === '' && (itemRows.filter((data) => (data.update_type !== 'D' && (data.row_type !== 'A' || data.update_type !== 'N')))).length === 0){ 
      msg = '발주 품목이 존재하지 않습니다.';
    }else if(msg === '' && updateItemRows.length > 0){ 
      for(let i = 0; i < updateItemRows.length; i++) {
        const purchase_item_id = updateItemRows[i].purchase_item_id;
        const purchase_package_count = updateItemRows[i].purchase_package_count;
        const purchase_item_price_currency = updateItemRows[i].purchase_item_price_currency;
        const purchase_item_sv_price = updateItemRows[i].purchase_item_sv_price;
        const purchase_item_vat_price = updateItemRows[i].purchase_item_vat_price;

        if(purchase_item_id === 0 || purchase_item_id === '') {
          msg = '선택되지 않는 발주 품목이 존재합니다.';
          break;
        }
        if(purchase_package_count === 0 || purchase_package_count === '' || purchase_package_count === null) {
          msg = '입력되지 않는 수량이 존재합니다.';
          break;
        }
        if(purchase_package_count < 0) {
          msg = '수량은 음수가 될 수 없습니다.';
          break;
        }
        if(purchase_item_price_currency === 0 || purchase_item_price_currency === '') {
          msg = '선택되지 않는 통화단위가 존재합니다.';
          break;
        }
        if(purchase_item_sv_price !== "" && purchase_item_sv_price < 0) {
          msg = '공급가액은 음수가 될 수 없습니다.';
          break;
        }
        if(purchase_item_vat_price !== "" && purchase_item_vat_price < 0) {
          msg = '부가세액은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    if(msg === '' && (userRows.filter((data) => data.update_type === 'U')).length > 0){
      for(let i = 0; i < updateUserRows.length; i++) {
        const purchase_user_id = updateUserRows[i].purchase_user_id;
        const purchase_user_type = updateUserRows[i].purchase_user_type;
        
        if(purchase_user_id === 0 || purchase_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(purchase_user_type === 0 || purchase_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">발주 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Purchase/Reg", {inputs, updateItemRows, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){

          if(updateFileRows.length > 0) {

            var selectID = inputs.purchase_id;
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Purchase');
            formData.append('type', 'Update');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              realFiles = []; tmpRealFiles = [];
              Swal.fire({
                title: '발주 수정 완료',
                text: '정상적으로 발주가 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }).catch(error => {
              appStore.capture();
            });

          }else{

            Swal.fire({
              title: '발주 수정 완료',
              text: '정상적으로 발주가 수정 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleView();
            });
            
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }
  };
  
  const fRow = { display: 'flex', gap: '30px' };
  const fCell = { display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 };
  const fLabel = { width: '120px', flexShrink: 0, fontWeight: 'bold', fontSize: '15px', color: '#333', whiteSpace: 'nowrap' };
  const fInput = { flex: 1, minWidth: 0, height: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '0 12px', fontSize: '15px', boxSizing: 'border-box' };

  return (
    <TabContext value={tabID}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fafafa', minHeight: '50px', paddingRight: '20px' }}>
          <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="정보" value="1" />
                <Tab label="품목" value="2" />
                <Tab label="담당자" value="3" />
                <Tab label="파일" value="4" />
          </TabList>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    
                    {updateFlag &&
                      (originRows[0].purchase_status === 'S'?
                        <Button 
                          onClick={ handlePurchaseUpdate }
                          className="btn-p btn-u"
                          
                          sx={{  
                              m: 0.5, 
                              fontSize: 14, 
                              color: "white", 
                              borderColor: "orange", 
                              backgroundColor: "orange",
                              ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                          }} 
                          variant="outlined">
                          발주취소
                        </Button>
                      :
                        <Button 
                          onClick={ handlePurchaseUpdate }
                          className="btn-p btn-u"
                          
                          sx={{  
                              m: 0.5, 
                              fontSize: 14, 
                              color: "white", 
                              borderColor: "#8041D9", 
                              backgroundColor: "#8041D9",
                              ":hover": { boxShadow: "2px 2px 2px #8041D9" , backgroundColor: "#8041D9", borderColor: "#8041D9"}
                          }} 
                          variant="outlined">
                          발주원복
                        </Button>
                      )
                    }
                    
                    {updateFlag &&
                    (originRows[0].purchase_status === 'D'?''
                    :                    
                      
                        <Button 
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{  
                              m: 0.5, 
                              fontSize: 14, 
                              color: "white", 
                              borderColor: "#FF3636", 
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }} 
                          variant="outlined">
                          수정
                        </Button>
                      
                    )}
                  </div>
        </Box>
        <div ref={tabPanelRef} style={{ flex: 1, overflow: 'hidden', backgroundColor: '#fff', minHeight: 0 }}>
          <TabPanel value="1" style={{ height: '100%', overflow: 'auto', padding: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '28px 34px', boxSizing: 'border-box', width: '100%' }}><div style={fRow}><div style={fCell}><label style={fLabel}>발주명 <span style={{ color: 'red' }}>*</span></label><input type="text" placeholder="발주명" value={inputs.purchase_name} name="purchase_name" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /></div><div style={fCell}><label style={fLabel}>발주번호</label><input type="text" placeholder="발주번호" value={inputs.purchase_number} name="purchase_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div></div><div style={fRow}><div style={fCell}><label style={fLabel}>발주일자 <span style={{ color: 'red' }}>*</span></label><input type="date" value={inputs.purchase_date} name="purchase_date" onChange={(e) => onDateChange(e) } autoComplete="off" style={fInput} /></div><div style={fCell}><label style={fLabel}>발주처 <span style={{ color: 'red' }}>*</span></label><input type="text" placeholder="발주처" value={inputs.purchase_partner_name} name="purchase_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#EFEFEF4D', cursor: 'pointer' }} readOnly /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>발주처 담당자</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="text" placeholder="이름" value={inputs.purchase_partner_manager} name="purchase_partner_manager" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 1 }} /><input type="text" placeholder="휴대폰번호" value={inputs.purchase_partner_manager_phone} name="purchase_partner_manager_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /><input type="text" placeholder="메일주소" value={inputs.purchase_partner_manager_mail} name="purchase_partner_manager_mail" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /></div></div><div style={{ display: 'flex', alignItems: 'flex-start' }}><label style={{ ...fLabel, marginTop: '10px' }}>비고</label><textarea placeholder="비고" name="purchase_bigo" value={inputs.purchase_bigo} onChange={(e) => onChange(e) } style={{ flex: 1, minWidth: 0, height: '110px', border: '1px solid #ccc', borderRadius: '4px', padding: '10px 12px', fontSize: '15px', resize: 'none', boxSizing: 'border-box' }} autoComplete="off"></textarea></div></div>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </div>
        </div>
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal hideDimensions={true}
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          upperPartnerId={upperPartnerId}
          nowIOType={'I'}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </TabContext>
  );
}

export default TAB_PurchaseUpdate;